import { NewWindowAnchor } from '@xo-union/component-standard-elements';
import React from 'react';

import { Room } from '../contexts/TransientRooms';
import shared from './hotelPlannerCard.scss';
import Row from './Row';

interface Props {
  rooms: Room[];
  showing: number;
  onClick: React.Dispatch<React.SetStateAction<number>>;
}

const ViewMoreButton: React.FC<Props> = ({ rooms, showing, onClick }) => {
  if (rooms.length > showing) {
    return (
      <Row>
        <NewWindowAnchor tabIndex="0" onClick={onClick} className={shared.viewMore}>
          View More
        </NewWindowAnchor>
      </Row>
    );
  }

  return null;
};

export default ViewMoreButton;
